import React from 'react';
import { ScrollReveal } from './ScrollReveal';
const cameThrough = ['A jewellery concept rooted in symbolism, connection, and emotional meaning.', 'A founder with real making experience, design instinct, and product credibility.', 'A desire to begin with one hero offer rather than launching too broadly.', 'A need for stronger clarity around the name, story, and positioning before going live.', 'A clear ambition to build something premium, personal, and commercially strong.'];
const matters = ['Meaning and connection', 'Craft and credibility', 'Customisation', 'Founder story', 'Premium positioning'];
const practical = ['Is the first sale more likely to come from self-purchase or gifting?', 'Should the main story lead with symbolism, product quality, or both?', 'What needs to feel premium from day one?', 'What makes the offer distinct enough from lower-cost alternatives?', 'How should your founder story be shared in a way that builds trust and value?'];
export function ClarityRecap() {
  return <section id="recap" className="py-20 md:py-32 px-5 md:px-10 bg-paper border-b border-rule/60" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <ScrollReveal data-id="element-45">
          <div className="mb-16 md:mb-20 max-w-2xl" data-id="element-46">
            <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-47">
              — Clarity Recap
            </p>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink font-light" data-id="element-48">
              What came through, in your own words.
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 gap-x-12" data-id="element-49">
          {/* Came through clearly */}
          <ScrollReveal className="lg:col-span-7" data-id="element-50">
            <div className="border-t border-ink pt-6" data-id="element-51">
              <h3 className="font-serif text-xl md:text-2xl text-ink mb-8 italic font-normal" data-id="element-52">
                What came through clearly
              </h3>
              <ul className="space-y-5" data-id="element-53">
                {cameThrough.map((item, i) => <li key={i} className="flex gap-5 text-base md:text-lg text-ink-soft leading-relaxed font-light" data-id="element-54">
                    <span className="font-serif text-gold text-sm pt-1.5 flex-shrink-0 italic" data-id="element-55">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span data-id="element-56">{item}</span>
                  </li>)}
              </ul>
            </div>
          </ScrollReveal>

          {/* What matters most */}
          <ScrollReveal className="lg:col-span-5" delay={0.1} data-id="element-57">
            <div className="border-t border-ink pt-6" data-id="element-58">
              <h3 className="font-serif text-xl md:text-2xl text-ink mb-4 italic font-normal" data-id="element-59">
                What appears to matter most
              </h3>
              <p className="text-sm text-ink-mute leading-relaxed font-light mb-8 italic" data-id="element-60">
                Early themes to shape and refine, not fixed brand truths.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-61">
                {matters.map(item => <span key={item} className="font-serif text-sm md:text-base text-ink bg-ivory border border-rule px-4 py-2 rounded-full italic" data-id="element-62">
                    {item}
                  </span>)}
              </div>
            </div>
          </ScrollReveal>

          {/* Practical steps */}
          <ScrollReveal className="lg:col-span-12" delay={0.15} data-id="element-63">
            <div className="border-t border-ink pt-6 mt-4" data-id="element-64">
              <h3 className="font-serif text-xl md:text-2xl text-ink mb-8 italic font-normal" data-id="element-65">
                Practical questions to sit with
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-66">
                {practical.map((q, i) => <div key={i} className="flex gap-5 pb-5 border-b border-rule/70" data-id="element-67">
                    <span className="font-serif text-gold text-xs pt-1 italic" data-id="element-68">
                      Q{i + 1}
                    </span>
                    <p className="text-base md:text-lg text-ink-soft leading-relaxed font-light" data-id="element-69">
                      {q}
                    </p>
                  </div>)}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}